import { motion, type Transition, type Variants } from "framer-motion";
import { ReactNode } from "react";
import { useDeviceInfo } from "@/hooks/useDeviceInfo";

interface PageTransitionProps {
  children: ReactNode;
}

const pageVariants: Variants = {
  initial: {
    opacity: 0,
    y: 10,
  },
  animate: {
    opacity: 1,
    y: 0,
  },
  exit: {
    opacity: 0,
    y: -10,
  },
};

const pageTransition: Transition = {
  type: "tween",
  ease: "easeInOut",
  duration: 0.25,
};

export function PageTransition({ children }: PageTransitionProps) {
  const { prefersReducedMotion } = useDeviceInfo();

  if (prefersReducedMotion) {
    return <>{children}</>;
  }

  return (
    <motion.div
      initial="initial"
      animate="animate"
      exit="exit"
      variants={pageVariants}
      transition={pageTransition}
    >
      {children}
    </motion.div>
  );
}
